// SeasonSelect.js — frosted pill season picker. Non-floating label; uses
// `renderValue` to prefix with "Season · " so it reads cleanly at pill
// size without the notched outlined-label clipping.

import React from "react";
import { Box, MenuItem, Select, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { BRAND } from "../../theme";
import { ALL_LABEL, buildSeasonOptions } from "./utils";

const SEASON_OPTIONS = buildSeasonOptions();

export default function SeasonSelect({ season, onChange }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: 999,
        pl: 1.5,
        pr: 0.5,
        py: 0.25,
        background: "rgba(20,20,26,0.7)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        border: `1px solid ${BRAND.divider}`,
        boxShadow:
          "0 4px 20px rgba(0,0,0,0.45), inset 0 0 0 1px rgba(255,255,255,0.04)",
        transition: "all 200ms ease",
        "&:hover": {
          borderColor: BRAND.cyan,
          boxShadow:
            "0 6px 26px rgba(57,208,255,0.25), inset 0 0 0 1px rgba(255,255,255,0.06)",
        },
      }}
    >
      <Typography
        sx={{
          color: BRAND.cyan,
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: "0.14em",
          textTransform: "uppercase",
          mr: 1,
          whiteSpace: "nowrap",
        }}
      >
        Season
      </Typography>
      <Select
        value={season}
        onChange={(e) => onChange(e.target.value)}
        variant="standard"
        disableUnderline
        sx={{
          fontSize: isMobile ? 12 : 14,
          fontWeight: 600,
          letterSpacing: "0.02em",
          color: "#fff",
          minWidth: isMobile ? 80 : 110,
          "& .MuiSelect-select": {
            py: 0.5,
            pl: 0.5,
            pr: "24px !important",
          },
          "& .MuiSvgIcon-root": { color: BRAND.cyan, right: 2 },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 1,
              bgcolor: "rgba(20,20,26,0.95)",
              backdropFilter: "blur(14px)",
              border: `1px solid ${BRAND.divider}`,
              borderRadius: 2,
              maxHeight: 360,
            },
          },
        }}
      >
        <MenuItem value={ALL_LABEL}>{ALL_LABEL}</MenuItem>
        {SEASON_OPTIONS.slice(1).map((label) => (
          <MenuItem key={label} value={label}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
